(function(angular){
	'use strict';

	angular
		.module('authModule', [
			'coreModule',
			'formValidationModule',
			'googleRecaptchaModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);